<template>
  <div>
    <v-list-item link @click="abrirDialogCarregamentoDeArquivos">
      <v-list-item-content>
        <v-list-item-title class="list-item">
          <v-list-item-icon style="margin: 0 13% 0 0">
            <v-icon>$Circulos</v-icon>
          </v-list-item-icon>

          <span>Análise de cotação</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-dialog
      v-model="dialog_ativo"
      content-class="bar-12"
      persistent
      width="90vw"
      transition="dialog-top-transition"
    >
      <v-card height="90vh" class="conteudo">
        <CarregandoArquivos
          v-if="!cotacoes_para_analise.fornecedores && !ultimaTela"
          @fechar-dialog="cancelar"
          @cotacoes-para-analisar="cotacoes_para_analise = $event"
        />

        <AnaliseProdutosDaCotacao
          v-else-if="cotacoes_para_analise.fornecedores && !ultimaTela"
          v-model="cotacoes_para_analise"
          @fechar-dialog="cancelar"
          @resetar-dialog="ultimaTela = true; message_errors = $event"
        />

        <ConclusaoDaAnalise v-else-if="ultimaTela" @fechar-dialog="cancelar" :message_errors="message_errors" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fases_analise_cotacoes  from "./ajudantes/Fases.js";
import CarregandoArquivos from "./carregamentoDeArquivos/Index.vue";
import AnaliseProdutosDaCotacao from "./analiseProdutosFornecedor/Index.vue";
import ConclusaoDaAnalise from "./conclusaoDaAnalise/Index.vue";

export default {
  name: "Index.vue",
  components: {
    AnaliseProdutosDaCotacao,
    CarregandoArquivos,
    ConclusaoDaAnalise
},
  data: () => ({
    ativarAnaliseCotacoes: null,
    dialog_ativo: false,
    fase_atual_analise_cotacoes: null,
    fases_analise_cotacoes,
    cotacoes_para_analise: {
      fornecedores: [],
      data: []
    },
    ultimaTela: false,
    message_errors: []
  }),
  mounted() {
    this.resetarFase();
    this.fase_atual_analise_cotacoes = this.fases_analise_cotacoes.carregamento_de_arquivos;
    this.ativarAnaliseCotacoes = Boolean(localStorage.compras_analise_por_departamentos);
  },
  methods: {
    abrirDialogCarregamentoDeArquivos() {
      this.$emit('selecionado', {});
      this.dialog_ativo = !this.dialog_ativo;
    },
    cancelar() {
      this.ultimaTela = false;
      this.dialog_ativo = false;
      this.resetarFase();
    },
    resetarFase() {
      this.fase_atual_analise_cotacoes = this.fases_analise_cotacoes.carregamento_de_arquivos;
      this.cotacoes_para_analise = {};
    }
  }
}
</script>

<style scoped>
</style>
